<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <el-row>
      <section ref="print">
        <table class="table_frame" width="100%" border="0" align="center" cellpadding="0" cellspacing="0">
          <tbody>
            <tr>
              <td>
                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td class="td_frame">
                        <table width="100%" border="0" cellpadding="0" cellspacing="0">
                          <tbody>
                            <tr>
                              <td colspan="3" style=" text-align: center;font-size: 16pt"><strong>盛塘国际发货单</strong></td>
                            </tr>
                            <tr>
                              <td width="25%">
                                <p>
                                  订货人
                                  <strong>
                                    ：
                                    <span>{{ form.ship_name }}</span>
                                  </strong>
                                </p>
                              </td>
                              <td width="25%">
                                <p>
                                  代理商
                                  <strong>
                                    ：
                                    <span>{{ form.user?form.user.real_name:"" }}</span>
                                  </strong>
                                </p>
                              </td>
                              <td width="50%" style="text-align: right;">
                                <p>
                                  发货日期：
                                  <span>{{ form.date }}</span>
                                </p>
                              </td>
                            </tr>
                            <tr>
                              <td colspan="3">
                                <p>
                                  收货人信息：
                                  <span>{{ form.ship_area + ',' + form.ship_addr }}</span>
                                  <span>{{ form.ship_name }}</span>
                                  <span>{{ form.ship_mobile }}</span>
                                </p>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td class="td_frame">
                <table width="98%" border="0" align="center" cellpadding="0" cellspacing="0">
                  <tbody>
                    <tr class="table_data_title">
                      <td width="40px">序号</td>
                      <td>商品名称</td>
                      <td width="50px" align="center">数量</td>
                    </tr>
                    <tr style="line-height:25px; " v-for="(item, index) in form.items" :key="index">
                      <td>{{ index + 1 }}</td>
                      <td>{{ item.name }}</td>
                      <td align="center">{{ item.nums }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td>
                <table width="100%" border="0" cellspacing="0" cellpadding="0">
                  <tbody>
                    <tr>
                      <td colspan="2" width="70%" style="text-align: center;"><p>总计</p></td>
                      <td width="30%" style="text-align: right;">
                        <p style="padding-right: 28px;">
                          <span>{{ form.item_num }}</span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td style="text-align: right;"><h1 style="margin-right: 100px;margin-top: 20px;">发货人：</h1></td>
            </tr>
            <tr>
              <td style="height: 30px; padding-bottom: 50px;" align="right" />
            </tr>
          </tbody>
        </table>
      </section>
    </el-row>
    <el-row type="flex" justify="center"><el-button @click="onPrint" type="primary">打印清单</el-button></el-row>
  </el-card>
</template>

<script>
import { editOrder } from '@/api/order-offline'
import FormHelper from '@c/LzForm/FormHelper'
import { getLocalData } from '@/libs/util'

export default {
  name: 'Form',
  components: {},
  mixins: [FormHelper],
  data() {
    return {
      form: {
        id: 0,
        order_id: '',
        user_id: 0,
        title: '',
        item_num: 0,
        freight: 0.0,
        pmt_amount: 0.0,
        total_amount: 0.0,
        final_amount: 0.0,
        league_order: 0.0,
        memo: '',
        status: 0,
        status_text: '',
        confirm_time: '',
        audit_date: '',
        audit_status: 0,
        audit_status_text: '',
        audit_time: '',
        pay_integral: '',
        pay_time: '',
        pay_status: 0,
        pick_up_order: '',
        ship_name: '',
        ship_addr: '',
        ship_aera_code: '',
        ship_area: '',
        ship_mobile: '',
        ship_time: '',
        express_no: '',
        express_company_code: '',
        express_company_name: '',
        delivery_id: '',
        belong_delivery_user_name: '',
        mark_text: '',
        user: {},
        items: [],
        logs: [],
        created_at: '',
        updated_at: '',
        date: getLocalData('d'),
      },
      errors: {},
    }
  },
  created() {
    this.getData()
  },
  methods: {
    async getData() {
      const { data } = await editOrder(this.resourceId)
      this.fillForm(data.data)
    },
    async onPrint() {
      this.$print(this.$refs.print)
    },
  },
}
</script>

<style scoped lang="scss">
.x-barcode {
  padding: 0;
  margin: 0;
}
body {
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
}
.td_frame {
  padding: 5px 0 5px 0;
  border-bottom: 2px solid #000000;
}
img {
  padding: 2px;
  border: 0;
}
p {
  margin: 8px 0 8px 0;
}
h1 {
  font-size: 16px;
  font-weight: bold;
  margin: 0;
}
h2 {
  font-size: 14px;
  font-weight: bold;
  margin: 0;
}
.table_data_title {
  font-size: 14px;
  font-weight: bold;
  height: 25px;
}
.table_data_content {
  height: 20px;
  line-height: 20px;
}
#print_confirm {
  width: 100%;
  height: 30px;
  border-top: 1px solid #999999;
  padding-top: 4px;
  position: absolute;
}
.noprint {
  display: block;
}
</style>
